<template>
    <Modal :title="$t('common.resell.modal.title')"
           :close-on-click-outside="false"
           @close="closeModal()"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
                <DateTimePicker
                    v-on:input="changeStartTime"
                    :value="form.startTime"
                    :placeholder="$t('common.startTime')"
                ></DateTimePicker>
                <DurrationSelect :no-table="true" @input="changeAuctionDuration"></DurrationSelect>
                <md-field>
                    <label>{{ $t("common.startPrice") }}</label>
                    <MoneyAmountInput v-model="form.startPrice"></MoneyAmountInput>
                </md-field>
                <md-field>
                    <label>{{ $t("common.fixedPrice") }}</label>
                    <MoneyAmountInput v-model="form.instantBuyPrice"></MoneyAmountInput>
                </md-field>
            </form>
            <div class="flex flex_between base_margin">
                <md-button class="md-blank" @click="closeModal()">{{ $t("common.button.cancel") }}</md-button>
                <md-button
                    class="opacity_5"
                    :class="{ 'md-primary': submitBtnStatus }"
                    @click="sell"
                >{{ $t("common.sell") }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";
import DateTimePicker from "@/components/templates/DateTimePicker";
import DurrationSelect from "@/components/templates/seller/sell/DurrationSelect";

export default {
    components: {
        DateTimePicker,
        Modal,
        MoneyAmountInput,
        DurrationSelect
    },
    props: {
        data: { type: Object }
    },
    data() {
        return {
            form: {
                startPrice: null,
                instantBuyPrice: null,
                startTime: "",
                durationInHours: null
            }
        };
    },
    computed: {
        submitBtnStatus() {
            return true;
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        changeStartTime(value) {
            this.form.startTime = value;
        },
        changeAuctionDuration(value) {
            this.form.durationInHours = value;
        },
        sell() {
            this.$emit("sell", {
                    data: this.data,
                    params: this.form
                }
            )
        },
    },
};
</script>

<style scoped>

</style>